import {svgIconWrapper} from '../svg-icon-wrapper';

import CompanyOverview from './icon-company-overview.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CompanyOverview {...validProps} />;
}

SvgComponent.iconName = 'company-overview';

export const CompanyOverviewIcon = svgIconWrapper(SvgComponent);
